import {cryptoSvg as Icon__small__cryptoSvg} from '../Icon__small/Icon__small--crypto.js'

export var crypto = {
  name: 'crypto',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cryptoSvg,
};
